import { createFileRoute } from '@tanstack/react-router';
import { OverviewIndex } from '@/features/administrator-panel/overview/OverviewIndex.tsx';

export const Route = createFileRoute('/admin/overview')({
  head: () => ({ meta: [{ title: 'Overview' }] }),
  component: OverviewIndex,
});
